import { post, get, IResponse } from "@Lib/request";
import { host, path } from "./url";
import dayjs from "dayjs";
import getUUID from "@Lib/uuid";
import getGeneralInfo from "@Lib/collectData";
import { EHistoryRecordType, ESenceType } from "@Types/constants";
import { IRegionsRequest } from "@Types/regions";
const { dc } = host;
const { usedCarApiV4, uploadApi, newCarApiV2, newCarApiV3, newCarApiV1, newCarApiV4, newCarApiV5 } = path;

export function postInitialCollect(data = {}, actionType?: string, site?: string) {
  return post(`${dc}/generic`, {
    es_tag: "t_advertising",
    action: {
      type: actionType,
      platform: "pc",
      time: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      site: site,
    },
    device: {
      userAgent: window.navigator.userAgent,
      deviceId: getUUID(),
    },
    data: data,
  });
}

export function postCollectData(data = {}) {
  return post(`${dc}/generic`, JSON.stringify(data)).then((res: any) => {
    if (res.data.status === 12000) {
      return res.data.data;
    }
    return res.data;
  });
}

export function postCollectBulkData(data = {}) {
  return post(`${dc}/genericBulk`, JSON.stringify(data)).then((res: any) => {
    if (res.data.status === 12000) {
      return res.data.data;
    }
    return res.data;
  });
}

export function fetchRegions() {
  return get<{
    tree: {
      value: number;
      label: string;
      children: {
        value: number;
        label: string;
      }[];
    }[];
  }>(`${usedCarApiV4}/common/regionTree`);
}

export function UploadFile(data: FormData) {
  return post<{
    access_path: string;
    full_size: string;
    path: string;
    save_path: string;
    message?: string;
  }>(uploadApi, data);
}

export function UploadFileDefine(data: FormData, url?: string) {
  if (!url) {
    return UploadFile(data);
  } else {
    return post(url, data);
  }
}

export function fetchMemberNavInfo() {
  return get<{
    account: string;
    item: {
      onsale: number;
      unopen: number;
    };
    notify: {
      rating: number;
      sysmsg: number;
    };
    status?: number;
  }>(`/user-getLoginedNav.html`);
}

export function behaviorCollect(data: any) {
  var originalInfo = getGeneralInfo();
  originalInfo.action.type = data.type;
  originalInfo.auto = { ...originalInfo.auto, ...data.data };
  return post(`${dc}/behavioral_push`, JSON.stringify(originalInfo));
}

// 验证码
export async function verificationCode(params) {
  return await post(`${newCarApiV2}/u/verificationCode`, params);
}

// 用户信息
export async function userInfo(params) {
  return await get(`${newCarApiV2}/u/userInfo`, params);
}

export async function agentAuthStatus(params?: any) {
  return await get(`${newCarApiV2}/agent/auth`, params);
}
export async function agentAuth(params?: any) {
  return await post(`${newCarApiV2}/agent/auth`, params);
}

export async function collect(id, type, position) {
  return await get(`${newCarApiV3}/collect`, { id, type, position });
}

export async function regions(params: IRegionsRequest) {
  return await get(`${newCarApiV3}/regions/nav`, params);
}

/** 新版本发送验证码 */
export async function verificationCode_v3(params: { type?: ESenceType; account?: string }): Promise<IResponse<any>> {
  return await post(`${newCarApiV3}/u/verificationCode`, params);
}

/** 新版更新历史记录/浏览数 */
export async function updateHistoryRecord(params: { id: string; type: EHistoryRecordType }): Promise<IResponse<any>> {
  return await get(`${newCarApiV3}/history/record`, params);
}
/** 获取地区 */
export async function getRegions(params: any) {
  return await get(`${newCarApiV3}/regions`, params);
}
/** 获取销售排行nav */
export async function getSalesRankingNav(params: any) {
  return await get(`${newCarApiV3}/hot/sell/nav`, params);
}
/** 获取实测排行nav */
export async function getSuperTestRankingNav(params: any) {
  return await get(`${newCarApiV3}/superTest/rankingNav`, params);
}
/** 获取实测排行list */
export async function getSalesRankingList(params: any) {
  return await get(`${newCarApiV3}/superTest/rankingList`, params);
}
/** 获取销售排行list */
export async function getSuperTestRankingList(params: any) {
  return await get(`${newCarApiV1}/hotsell`, params);
}
/** 获取电车续航排行list */
export async function getBatteryLifeRankingList(params: any) {
  return await get(`${newCarApiV4}/ev/battery-life/rank`, params);
}

// 特辑详情
export async function fetchSpecialAlbumsss(params?: any) {
  return await get<any>(`${newCarApiV3}/collection/details`, params);
}
// 查询特辑入口开关状态
export async function fetchSpecialSwitch() {
  return await get<any>(`${newCarApiV3}/collection/switch`);
}
// 特辑列表页
export async function fetchSpecialList() {
  return await get<{
    list: any;
  }>(`${newCarApiV3}/collection/list`);
}

// 点赞、取消点赞（V3）
export async function fetchLike(params: any) {
  return await post(`${newCarApiV3}/like`, params);
}

// 点赞状态（V3）
export async function fetchLikeStatus(params: any) {
  return await get(`${newCarApiV3}/like/status`, params);
}

// 获取V5厂牌选择
export async function fetchV5BrandSelect(params: any) {
  return await get(`${newCarApiV5}/common/brand-select`, params);
}

// 获取V5车款选择
export async function fetchV5KindsSelect(params: any) {
  return await get(`${newCarApiV5}/common/kind-select`, params);
}

// 获取V5车型选择
export async function fetchV5ModelSelect(params: any) {
  return await get(`${newCarApiV5}/common/model-select`, params);
}


